import { AlertController, Platform, ToastController } from '@ionic/angular';
import { Subscriber } from 'rxjs';
import { isPresent } from '../src/providers/common-service';
import { ConnectionService } from '../src/providers/connection-service/connection-service';
import { HttpResponse } from '@angular/common/http';
/**
 * Created by Ashok on 08-06-2016.
 */

type MessagePosition = 'bottom' | 'top' | 'middle';

export class MessageDisplayUtil {
  /**
   * Gets the error message from an error
   * @param error
   * @returns {null}
   */
  public static getErrorMessage(error: any, defMsg?: string): string {
    let msg = null;

    if (error && error.message) msg = error.message;
    else if (error && error.errorMessage) msg = error.errorMessage;
    else if (error && error.exception) msg = error.exception;
    else if (typeof error === 'string') msg = error;
    else if (error instanceof HttpResponse) {
      let errorMsg = (msg = error.headers.get('error-message'));
      if (isPresent(errorMsg)) msg = errorMsg;
    } else msg = defMsg;
    if (!msg && isPresent(defMsg)) msg = defMsg;
    // else if(error)
    //     msg = JSON.stringify(error);
    return msg;
  }

  /**
   * This will extract the error message from error object. If error is empty then
   * default message is derived by concatenting passed default message and after checking network connection
   * @param error
   * @param platform
   * @param connService
   * @param defMessage
   */
  public static getError(
    error: any,
    platform: Platform,
    connService: ConnectionService,
    defMessage: string
  ): string {
    if (platform.is('capacitor') && !connService.isConnected()) {
      defMessage = 'You do not have data connection.';
    }
    let msg = MessageDisplayUtil.getErrorMessage(error, defMessage);
    return msg;
  }
  public static showErrorToast(
    message: string,
    platform: Platform,
    toastCtl: ToastController,
    duration: number,
    position: MessagePosition
  ) {
    MessageDisplayUtil._showToast(message, platform, toastCtl, duration, position, true);
  }

  public static showMessageToast(
    message: string,
    platform: Platform,
    toastCtl: ToastController,
    duration: number,
    position: MessagePosition,
    color: string = '',
    layout: string = ''
  ) {
    MessageDisplayUtil._showToast(
      message,
      platform,
      toastCtl,
      duration,
      position,
      false,
      color,
      layout
    );
  }

  private static _showToast(
    message: string,
    platform: Platform,
    toastCtl: ToastController,
    duration: number,
    position: MessagePosition,
    error: boolean,
    color: string = '',
    layout: string = ''
  ) {
    let toast = toastCtl
      .create({
        message: message,
        // message: 'dddfdf',
        duration: duration,
        position: position ? position : 'bottom',
        color: error ? 'danger' : color,
        // layout: layout,
        buttons: [
          {
            text: 'close', //Toast button changed from cancel to close
            role: 'cancel',
            handler: () => {},
          },
        ],
        // showCloseButton: true,
        // position       : position
      })
      .then((data: any) => {
        data.present({ keyboardClose: true });
      });
    // }
  }

  public static displayInfoAlert(
    alertCtl: AlertController,
    title: string,
    message: string,
    buttonText: string,
    subscriber?: Subscriber<any>
  ) {
    message =
      '<span class="info"><i class="fa fa-info-circle fa-2x" aria-hidden="true"></i>  ' +
      message +
      '</span>';
    let alert = alertCtl
      .create({
        header: title,
        message: message,
        // message: "sdfsfsdfsdf",
        buttons: [
          {
            text: buttonText,
            role: 'cancel',
            handler: (data: any) => {
              // data.dismiss().then(() => {
              if (subscriber && subscriber.next) subscriber.next();
              // });
              return false;
            },
          },
        ],
      })
      .then((res: any) => {
        res.present();
      });
  }

  public static displayErrorAlert(
    alertCtl: AlertController,
    title: string,
    message: string,
    buttonText: string,
    subscriber?: Subscriber<any>
  ) {
    message =
      '<span class="error"><i class="fa fa-exclamation-circle fa-2x" aria-hidden="true"></i> ' +
      message +
      '</span>';
    let alert: any = alertCtl
      .create({
        header: title,
        message: message,
        buttons: [
          {
            text: buttonText,
            role: 'cancel',
            handler: (data: any) => {
              // data.dismiss().then(() => {
              //   if (subscriber && subscriber.next) subscriber.next();
              // });
              if (subscriber && subscriber.next) subscriber.next();
              // alert.dismiss()
              // .then(() => {
              //     if (subscriber && subscriber.next)
              //         subscriber.next();
              // });

              return false;
            },
          },
        ],
      })
      .then((res: any) => {
        res.present();
      });
  }
}
